import { RoleType, SidebarId } from '@/enums'

export const sidebarOpenWidth = 253 // Width - When the sidebar is open
export const sidebarClosedWidth = 78 // Width - When the sidebar is close

/**
 * SidebarIds: This is an array with the list of items that each role has access.
 * This works to print the list of items in the sidebar
 */
export const SidebarIds: { [id: number]: { ids: SidebarId[] } } = {
  [RoleType.SUPER_ADMIN]: {
    ids: [
      SidebarId.HOME,
      SidebarId.REPORTS,
      SidebarId.REPORTS_BALANCE,
      SidebarId.USERS,
      SidebarId.BONUS_ENGINE,
      SidebarId.BONUS_WALLETS,
      SidebarId.SPORT_RO_CALCULATOR,
    ],
  },
  [RoleType.MANAGER]: {
    ids: [
      SidebarId.HOME,
      SidebarId.REPORTS,
      SidebarId.REPORTS_BALANCE,
      SidebarId.BONUS_ENGINE,
      SidebarId.BONUS_WALLETS,
      SidebarId.SPORT_RO_CALCULATOR,
    ],
  },
  [RoleType.AGENT]: {
    ids: [
      SidebarId.HOME,
      SidebarId.REPORTS,
      SidebarId.REPORTS_BALANCE,
      SidebarId.BONUS_ENGINE,
      SidebarId.BONUS_WALLETS,
      SidebarId.SPORT_RO_CALCULATOR,
    ],
  },
}
